if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
        this.hasPlatformGrid = this.dataset.sharePlatforms === 'true';

        if (navigator.share && !this.hasPlatformGrid) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            .addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__close')?.addEventListener('click', this.close.bind(this));
          this.updatePlatformLinks();
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage?.classList.add('hidden');
          if (this.elements.successMessage) this.elements.successMessage.textContent = '';
          this.elements.closeButton?.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton?.classList.remove('hidden');
          (this.elements.closeButton || this.mainDetailsToggle.querySelector('.share-button__copy'))?.focus();
        });
      }

      updateUrl(url) {
        this.urlToShare = url;
        if (this.elements.urlInput) this.elements.urlInput.value = url;
        this.updatePlatformLinks();
      }

      updatePlatformLinks() {
        if (!this.hasPlatformGrid) return;
        const url = this.urlToShare || document.location.href;
        const title = this.dataset.shareTitle || document.title;
        const image = this.dataset.shareImage || '';
        const encodedUrl = encodeURIComponent(url);
        const encodedTitle = encodeURIComponent(title);
        const encodedMessage = encodeURIComponent(`${title} ${url}`.trim());
        const destinations = {
          facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
          x: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
          pinterest: `https://www.pinterest.com/pin/create/button/?url=${encodedUrl}${image ? `&media=${encodeURIComponent(image)}` : ''}&description=${encodedTitle}`,
          reddit: `https://www.reddit.com/submit?url=${encodedUrl}&title=${encodedTitle}`,
          whatsapp: `https://wa.me/?text=${encodedMessage}`,
          email: `mailto:?subject=${encodedTitle}&body=${encodedMessage}`,
        };

        this.querySelectorAll('[data-share-platform]').forEach((link) => {
          const destination = destinations[link.dataset.sharePlatform];
          if (destination) link.setAttribute('href', destination);
        });
      }
    }
  );
}
